<template>
  <LibraryListItem>
    <DpplSimpleCheckbox
      v-if="showCheckbox"
      :model-value="selected"
      :option="{ id: ulid, label: '' }"
      hide-label
      size="md"
      border-radius="6px"
      class="checkbox"
      @click.stop
      @update:model-value="$emit('update:selected', $event)"
    />

    <div class="document-title text-textDarkest">
      {{ title }}
    </div>

    <BasicCellWithTooltip :text="jobCode" />
    <BasicCellWithTooltip :text="jobFamily" />
    <BasicCellWithTooltip :text="jobLevel" />
    <BasicCellWithTooltip :text="effectiveOnDate" />
  </LibraryListItem>
</template>

<script setup>
import { computed } from 'vue';
import LibraryListItem from '@/components/shared/LibraryListItem.vue';
import BasicCellWithTooltip from '@/components/jobProfiles/profileListItemCells/BasicCellWithTooltip.vue';
import DpplSimpleCheckbox from '@/components/datapeople/DpplSimpleCheckbox.vue';

const props = defineProps({
  ulid: { type: String, default: '' },
  title: { type: String, default: '' },
  jobCode: { type: String, default: '' },
  jobFamily: { type: String, default: '' },
  jobLevel: { type: String, default: '' },
  effectiveOn: { type: String, default: '' },
  selected: { type: Boolean, default: false },
  showCheckbox: { type: Boolean, default: false },
});

defineEmits(['update:selected']);

const effectiveOnDate = computed(
  () => (props.effectiveOn ? new Date(props.effectiveOn).toLocaleDateString('en-US') : ''),
);
</script>

<style lang="less" scoped>
.document-list-item {
  grid-template-columns: repeat(2, 1fr);
}

.checkbox {
  margin: 0 auto;
}

.document-title {
  font-size: 15px;
  max-width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
</style>
